import ButtonLinkPrimary from "./ButtonLinkPrimary";
import React from "react";
import PropTypes from "prop-types";

export default class PositionListButton extends ButtonLinkPrimary
{
    static propTypes = {
        positionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        language: PropTypes.string,
        customerName: PropTypes.string.isRequired,
    };

    buttonType = 'button-positions-list';

    constructor(props) {
        super(props);
        this.state = {
            loading: false
        };
    }

    render() {
        return (
            <ButtonLinkPrimary
                positionId={this.props.positionId}
                customerName = {this.props.customerName}
                href={'/'+ this.props.language + '/gate/'+ this.props.customerName + '/positions'}
                className={'col-12 btn btn-primary cursor-pointer specialButton ' + this.buttonType}
                buttonType = {this.buttonType}
            >
                <span>
                    {window.Translator.getSlug('GoBackToOpenPositions', this.props.language)}
                </span>
            </ButtonLinkPrimary>
        )
    }
}
